import { render } from "./Extended.vue?vue&type=template&id=6a43004a&scoped=true"
import script from "./Extended.vue?vue&type=script&lang=js"
export * from "./Extended.vue?vue&type=script&lang=js"

import "./Extended.vue?vue&type=style&index=0&id=6a43004a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a43004a"]])

export default __exports__